import styled from "styled-components";

const Styles = styled.div`
  /* 공통 */
  height: 100vh;
  & > .ant-layout {
    height: 100vh;
    background: #fff;
    & .ant-layout {
      background: inherit;
    }
  }
  & .ant-layout-sider-light {
    border-right: 1px solid #e3e3e3;
    & .ant-menu-inline {
      border-right: 0;
    }
  }

  & .ant-tabs {
    overflow: visible;
  }

  /* Single Page 유형 */
  &.single-page-layout {
  }

  /* Sidebar가 있는 Sub Page 유형 */
  &.sub-page-layout {
  }
`;

export default Styles;
